export default {"src":"/_next/static/media/project-logo-bab.0219c3fc.svg","height":48,"width":74,"blurWidth":0,"blurHeight":0};